export default "__VITE_ASSET__d603e189__"